import {colors} from "@mui/material";

export const defaultThemeOptions = {
    components: {
        MuiTooltip: {
            styleOverrides: {
                root: {
                    '.MuiTooltip-popper': {
                        background: 'rgb(38 50 56)',
                        fontSize: '0.75rem',
                        lineHeight: '1rem'
                    }
                }
            }
        }
    }
};

/**
 * The mustHaveThemeOptions object defines the options that must be present in the MUI theme.
 */
export const mustHaveThemeOptions = {
    typography: {
        htmlFontSize: 10,
        fontSize: 14,
        body1: {
            fontSize: '1.4rem'
        },
        body2: {
            fontSize: '1.4rem'
        }
    },
    palette: {
        background: {
            default: colors.common.white,
            paper: colors.grey[100],
        }
    }
};
